import {
  CircularProgress,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
  Button,
  Dialog,
  DialogTitle,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";

import queryString from "query-string";
import { Link, useLocation } from "react-router-dom";
import { removeEmptyValueObject } from "../../utils/helpers";
import useQuery from "../../utils/hook/useQuery";
import List from "./components/list";
import handleError from "../../utils/handleError";
import {
  getAllTicket,
  getStatusCounts,
  getStatusCountsByCreator,
} from "../../api/ticket/get";
import CreateTicket from "./components/registerTicket";
import RenderFilter from "../../utils/listDaynamicFilterHookForm";
import type { Filter } from "../../utils/listDaynamicFilter";
import {
  mdiAccountOutline,
  mdiStateMachine,
  mdiCalendar,
  mdiHomeSearchOutline,
} from "@mdi/js";

const useStyles = makeStyles((theme) =>
  createStyles({
    loading: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "50vh",
      alignSelf: "center",
      justifyContent: "center",
      background: "#ccc",
    },
    mainContainer: {
      backgroundColor: "#fff",
      padding: "24px",
      borderRadius: "4px",
    },
    headerBox: {
      marginLeft: "75px",
      display: "flex",
      alignItems: "center",
      marginBottom: "10px",
      marginTop: "10px",
    },
    mobile: {
      maxWidth: "120%",
      margin: "16px 0",
      "@media (max-width: 480px)": {
        marginTop: "140px",
      },
    },
    card: {
      width: "100%",
      marginBottom: "14px",
      overflow: "visible",
      padding: "14px 0 0",
      paddingBottom: "0",
    },
    cards: {
      position: "relative",
      backgroundColor: "white",
      padding: "14px",
      cursor: "pointer",
    },
    boxshadow: {
      position: "relative",
      backgroundColor: "white",
      padding: "14px",
      transform: "translateY(-3px)",
      boxShadow: "-6px 6px 14px 0px rgba(0,0,0,0.15) !important",
    },
    iconHeader: {
      position: "absolute",
      top: "5px",
      right: "5px",
    },
    cardContent: {
      marginTop: "-40px",
      display: "flex",
      textAlign: "center",
      paddingBottom: "12px !important",
    },
    cardContentlist: {
      justifyContent: "space-between",
      padding: " 0",
    },
    icon: {
      backgroundColor: "#f5f5f5",
      padding: "10px",
    },
  })
);

const sum = (arr: number[]) => {
  return arr.reduce((acc, current) => {
    if (current && current > 0) {
      return acc + current;
    } else {
      return acc;
    }
  }, 0);
};
const SUPPORT_PENDING = [
  "SUPPORT_PENDING",
  "SUPPORT_OPEN",
  "SUPPORT_OWNER_ANSWERED",
  "FFC_OWNER_ANSWERED",
  "PARTNER_ASSIGNEE_ANSWERED",
];
const FFC_PENDING = [
  "FFC_PENDING",
  "FFC_OWNER_ANSWERED",
  "FFC_ASSIGNEE_ANSWERED",
];
const PARTNER_OPEN = ["PARTNER_OPEN"];
const PARTNER_PENDING = [
  "PARTNER_PENDING",
  "PARTNER_OWNER_ANSWERED",
  "SUPPORT_ASSIGNEE_ANSWERED",
];
const CLOSED = ["SUPPORT_CLOSED", "PARTNER_CLOSED", "FFC_CLOSED"];

const TicketingListView = (props) => {
  const { search } = useLocation();
  const classes = useStyles();
  const filters: Filter[] = [
    {
      type: "input",
      id: "tracking.gte",
      label: "شماره تیکت از",
      icon: mdiAccountOutline,
    },
    {
      type: "input",
      id: "tracking.lte",
      label: "شماره تیکت تا",
      icon: mdiAccountOutline,
    },
    {
      type: "input",
      id: "department.name",
      label: "نام دپارتمان",
      icon: mdiAccountOutline,
    },
    {
      type: "input",
      id: "title.substring",
      label: "کلمه کلیدی عنوان",
      icon: mdiAccountOutline,
    },
    {
      type: "input",
      id: "linkId",
      label: "سفارش یا محموله",
      icon: mdiAccountOutline,
    },
    {
      type: "input",
      id: "creator.username",
      label: "نام سازنده",
      icon: mdiAccountOutline,
    },
    {
      type: "input",
      id: "assignee.username",
      label: "نام گیرنده",
      icon: mdiAccountOutline,
    },
    {
      type: "checkbox",
      id: "assignmentType.in",
      label: "‌مبدا ارسال",
      data: ["FFC", "PARTNER"],
      translateType: "ticket",
      icon: mdiStateMachine,
    },
    {
      type: "input",
      id: "partner.username",
      label: "نام پارتنر",
      icon: mdiAccountOutline,
    },
    {
      type: "input",
      id: "partner.id",
      label: "شناسه پارتنر",
      icon: mdiAccountOutline,
    },
    {
      type: "checkbox",
      id: "status.in",
      label: "وضعیت",
      data: [
        "OWNER_ANSWERED",
        "OPEN",
        "PENDING",
        "ASSIGNEE_ANSWERED",
        "CLOSED",
      ],
      translateType: "ticket",
      icon: mdiStateMachine,
    },
    {
      type: "checkbox",
      id: "priority.in",
      label: "الویت",
      data: ["LOW", "NORMAL", "HIGH", "CRITICAL"],
      translateType: "ticket",
      icon: mdiStateMachine,
    },
    {
      type: "date-picker",
      id: "createdAt.gte",
      label: "تاریخ ایجاد از",
      icon: mdiCalendar,
    },
    {
      type: "date-picker",
      id: "createdAt.lt",
      label: "تاریخ ایجاد تا",
      icon: mdiCalendar,
    },
    {
      type: "date-picker",
      id: "updatedAt.gte",
      label: "تاریخ ویرایش از",
      icon: mdiCalendar,
    },
    {
      type: "date-picker",
      id: "updatedAt.lt",
      label: "تاریخ ویرایش تا",
      icon: mdiCalendar,
    },
    {
      type: "input",
      id: "subject.body",
      label: "موضوع",
      icon: mdiHomeSearchOutline,
    },
  ];
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 100,
    ...queryString.parse(search),
  });
  const [ticketCounts, setTicketCounts] = useState(0);
  const [openSize, setOpenSize] = React.useState(false as boolean);

  const [cardCounts, setCardCounts] = useState({});
  const [openMsg, setOpenMsg] = useState(false);
  const [loading, setLoading] = useState(true);
  const [finalizedTicketsList, setFinalTickets] = useState<any>([]);

  useEffect(() => {
    getTickets();
    gettingTicketCount(request);
    getStatusCountsByCreator();
  }, [filtersValues]);

  const checkActiveCard = (name) => {
    const status = filtersValues["advanceItem.in"];
    switch (name) {
      case "SUPPORT_PENDING":
        return status === SUPPORT_PENDING.join(",");
      case "FFC_PENDING":
        return status === FFC_PENDING.join(",");
      case "PARTNER_OPEN":
        return status === PARTNER_OPEN.join(",");
      case "PARTNER_PENDING":
        return status === PARTNER_PENDING.join(",");
      case "CLOSED":
        return status === CLOSED.join(",");
    }
  };

  const handleCardClose = () => {
    const newFilterValues = { ...filtersValues };
    delete newFilterValues["advanceItem.in"];
    setFiltersValues({
      ...removeEmptyValueObject(newFilterValues),
      page: 0,
      size: 100,
    });
  };

  const handleCardClick = (name) => {
    switch (name) {
      case "SUPPORT_PENDING":
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          "advanceItem.in": SUPPORT_PENDING,
          page: 0,
          size: 100,
        });
        break;
      case "FFC_PENDING":
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          "advanceItem.in": FFC_PENDING,
          page: 0,
          size: 100,
        });
        break;
      case "PARTNER_OPEN":
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          "advanceItem.in": ["PARTNER_OPEN"],

          page: 0,
          size: 100,
        });
        break;
      case "PARTNER_PENDING":
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          "advanceItem.in": PARTNER_PENDING,
          page: 0,
          size: 100,
        });
        break;
      case "CLOSED":
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          "advanceItem.in": CLOSED,
          page: 0,
          size: 100,
        });
        break;
    }
  };

  const getTickets = async () => {
    try {
      const res = await getAllTicket(filtersValues);
      setFinalTickets(res.data.content);
      setTicketCounts(res.data.totalCount);
    } catch (error) {
      handleError(error);
    }
  };

  const gettingTicketCount = async (actions: any) => {
    try {
      setLoading(true);
      const counts = await getStatusCounts();
      setCardCounts(counts.data);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  const request = {
    openCount: {
      status: "OPEN",
    },
    closeCount: {
      status: "CLOSED",
    },
    answeredCount: {
      status: "ASSIGNEE_ANSWERED",
    },
    ownerAnsweredCount: {
      status: "OWNER_ANSWERED",
    },
  };

  const handleClose = () => {
    setOpenSize(false);
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const handleChangeSizePage = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const handleCloseModal = () => {
    setOpenMsg(false);
  };

  return (
    <React.Fragment>
      <Grid container xs={12} sm={12} alignItems="center" style={{ marginBottom: "16px" }}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" component="div">
            پشتیبانی
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} >
          <RenderFilter
            filters={filters}
            onFilter={(filtervalues: any) => {
              setFiltersValues({
                ...removeEmptyValueObject(filtervalues),
                page: 0,
                size: 100,
              });
            }}
            mainFiltersCount={0}
            baseFilter={{
              type: "input",
              id: "tracking",
              placeholder: "شناسه تیکت",
            }}
            filterValues={filtersValues}
          />
        </Grid>
      </Grid>
      <div className={classes.mainContainer}>
        <Grid
          container
          direction="row"
          alignItems="center"
          spacing={2}
          style={{ marginBottom: "24px" }}
        >
          
          <Grid item>
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={() => setOpenMsg(true)}
            >
              {`تیکت جدید`}
            </Button>
          </Grid>
          <Grid item>
            <Link to={"/ticketing"}>
              <Button variant="outlined" size="small" color="secondary">
                داشبورد
              </Button>
            </Link>
          </Grid>
          
        </Grid>
        
        {loading ? (
          <div className={classes.loading}>
            <CircularProgress />
          </div>
        ) : (
          <>
            {finalizedTicketsList?.length > 0 ? (
              <List data={finalizedTicketsList} />
            ) : (
              <Typography variant="h3" component="div">
                تیکت موجود نیست
              </Typography>
            )}
          </>
        )}
        <Grid item xs={12} sm={12} style={{ marginTop: "24px" }}>
          {finalizedTicketsList?.length > 0 && (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <FormControl
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div style={{ marginLeft: "10px", color: "#8a8a8a" }}>
                  {" "}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSize}
                  onClose={handleClose}
                  onOpen={() => setOpenSize(true)}
                  value={filtersValues.size}
                  onChange={handleChangeSizePage}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
              <Pagination
                count={Math.ceil(ticketCounts / filtersValues.size)}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
            </div>
          )}
        </Grid>
      </div>
      <Dialog
        open={openMsg}
        onClose={handleCloseModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth="sm"
        fullWidth
        style={{ padding: "16px" }}
      >
        <DialogTitle>
          <Grid container justifyContent="center" justify="center">
            <p style={{ marginTop: "-8px" }}>ایجاد تیکت جدید</p>
          </Grid>
        </DialogTitle>

        <Grid container direction="column">
          <CreateTicket
            handleCloseModal={handleCloseModal}
            getTickets={getTickets}
          />
        </Grid>
      </Dialog>
    </React.Fragment>
  );
};

export default TicketingListView;
